<script>
/**
 * Descripción: Botones para la DataTables
 *
 * @displayName BaseButtonsGrid
 */

import BaseLocalHelper from '@/helpers/BaseLocalHelper';

export default {
  name: 'BaseButtonsGrid',

  props: {
    /**
     * Función Refrescar
     * Default undefined
     */
    fnRefresh: {
      type: Function,
      default: undefined
    },

    /**
     * Función Filtrar Columnas
     * Default undefined
     */
    fnFilter: {
      type: Function,
      default: undefined
    },

    /**
     * Función Nuevo
     * Default undefined
     */
    fnNew: {
      type: Function,
      default: undefined
    },

    /**
     * Función Editar
     * Default undefined
     */
    fnEdit: {
      type: Function,
      default: undefined
    },

    /**
     * Función Eliminar
     * Default undefined
     */
    fnDelete: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      items: [],

      lblNew: BaseLocalHelper.$_LabelBtnNew,

      lblEdit: BaseLocalHelper.$_LabelBtnEdit,

      lblDelete: BaseLocalHelper.$_LabelBtnDelete,

      lblRefresh: BaseLocalHelper.$_LabelBtnRefresh,

      lblFilter: BaseLocalHelper.$_LabelBtnFilter
    };
  },

  /**
   * Pintar buttons requeridos para el DataTable
   */
  created() {
    this.fnRefresh != undefined
      ? this.items.push(true)
      : this.items.push(false);

    this.fnFilter != undefined ? this.items.push(true) : this.items.push(false);

    this.fnNew != undefined ? this.items.push(true) : this.items.push(false);

    this.fnEdit != undefined ? this.items.push(true) : this.items.push(false);

    this.fnDelete != undefined ? this.items.push(true) : this.items.push(false);
  },

  /**
   * Ejecutar Click de los buttons
   */
  methods: {
    $_Refresh() {
      this.fnRefresh();
    },

    $_Filter() {
      this.fnFilter();
    },

    $_New() {
      this.fnNew();
    },

    $_Edit() {
      this.fnEdit();
    },

    $_Delete() {
      this.fnDelete();
    }
  }
};
</script>

<template>
  <div id="app">
    <v-row>
      <v-tooltip top v-if="items[0]">
        <template v-slot:activator="{ on }">
          <v-btn icon color="black" @click="$_Refresh" v-on="on">
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </template>
        <span>{{ lblRefresh }}</span>
      </v-tooltip>
      <v-tooltip top v-if="items[1]">
        <template v-slot:activator="{ on }">
          <v-btn icon color="black" @click="$_Filter" v-on="on">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <span>{{ lblFilter }}</span>
      </v-tooltip>
      <v-btn class="ma-1" depressed small v-if="items[2]" @click="$_New">
        <v-icon color="black" left>mdi-gamepad-round-outline</v-icon>
        {{ lblNew }}
      </v-btn>
      <v-btn class="ma-1" depressed small v-if="items[3]" @click="$_Edit">
        <v-icon color="black" left>mdi-square-edit-outline</v-icon>
        {{ lblEdit }}
      </v-btn>
      <v-btn class="ma-1" depressed small v-if="items[4]" @click="$_Delete">
        <v-icon color="black" left>mdi-trash-can-outline</v-icon>
        {{ lblDelete }}
      </v-btn>
      <!-- @slot Use este slot para agregar más botones -->
      <slot name="btns"></slot>
    </v-row>
  </div>
</template>
